/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inyourtimezone3Inputs */



/**
* | output |
* | --- |
* | "in your time zone" |
*
* @param {Inyourtimezone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const inyourtimezone3 = /** @type {((inputs?: Inyourtimezone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inyourtimezone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("in your time zone")
	return /** @type {LocalizedString} */ ("in deiner Zeitzone")
});
export { inyourtimezone3 as "inYourTimeZone" }